import styled from 'styled-components';
import { Main } from '../../styles';
export const PageTitle = styled.h1`
  margin-block-end: 0;
`;

export const CharContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;
export const MainContainer = styled(Main)`
  padding: 20px;
`;
